import React from 'react'
import { Helmet, HelmetProps } from 'react-helmet'

const Head: React.FC<HelmetProps> = (props: HelmetProps) => {
  return <Helmet titleTemplate={`%s | Plant pal`} {...props} />
}

export default Head
